function getEventAttributesFromButton(button) {
  const id = $(button).attr("data-ssid")
  const createdAt = $(button).attr("data-ss-created-at")
  const language = $(button).attr("data-ss-language")
  const format = $(button).attr("data-ss-format")

  return {
    slideshow_id: id,
    slideshow_created_at: createdAt,
    slideshow_language: language,
    slideshow_format: format,
    source: window.location.pathname,
  }
}

$(".j-favorite").click(function () {
  const eventAttributes = getEventAttributesFromButton(this)

  if ($(this).hasClass("favorited")) {
    amplitude.getInstance().logEvent("slideshow_unliked", eventAttributes)
  } else {
    amplitude.getInstance().logEvent("slideshow_liked", eventAttributes)
  }
})

$(".j-share").click(function () {
  const eventAttributes = getEventAttributesFromButton(this)

  amplitude.getInstance().logEvent("slideshow_share_initiated", eventAttributes)
})
